// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__iaojz","footer":"ReportModalFilter_footer__F-w0Q"};